export default __webpack_public_path__ + "static/media/first-item-bg.5828a3a0.svg";